import { AppButton, AppModal } from '@/shared/ui'
import { FunctionComponent, useEffect, useState } from 'react'
import { UNITS } from '../../constants/constants'
import { Product } from '../admin-product-card/product-types'
import { RejectItem } from './reject-item'

type RejectItemModalLabels = {
  [key: string]: string
}

/**
 * Label texts.
 */
const LABELS: RejectItemModalLabels = {
  cancel: 'Cancel',
  reject: 'Reject'
}

/**
 * Properties type for RejectItem component.
 */
export type RejectItemModalProps = {
  product?: Product
  visible?: boolean
  title?: React.ReactNode
  className?: string
  copy?: (text: string) => string
  onCancel?: () => void
  onReject?: (value: number) => void
}

/**
 * Component that shows UI for reject items in a job.
 *
 * @param param0 {RejectItemProps} Properties
 */
export const RejectItemModal: FunctionComponent<RejectItemModalProps> = ({
  product = {
    quantity: 0,
    name: 'Long long long long long long name',
    um: ''
  },
  title,
  visible = false,
  className = '',
  copy = (text: string): string => (LABELS[text] ? LABELS[text] : text),
  onCancel = () => {},
  onReject = () => {}
}: RejectItemModalProps): JSX.Element => {
  const { um, quantity } = product

  const [modalVisible, setModalVisible] = useState(false)
  const [value, setValue] = useState(UNITS[um ?? ''] ? Math.min(0.1, quantity ?? 0.1) : 1)

  const cancel = () => {
    setModalVisible(false)
    onCancel()
  }

  const reject = () => {
    onReject(value)
    setModalVisible(false)
  }

  const change = (value: number) => {
    setValue(value)
  }

  useEffect(() => {
    setModalVisible(visible)
  }, [visible])

  useEffect(() => {
    setValue(UNITS[um ?? ''] ? Math.min(0.1, quantity ?? 0.1) : 1)
  }, [product.quantity])

  return (
    <AppModal
      open={modalVisible}
      className={`gungnir-reject-item-modal ${className}`}
      title={title}
      width={700}
      onCancel={cancel}
      footer={[
        <span className='gungnir-rim-footer-text' key='gungnir-rim-text'>
          {`${copy('youAreRejecting')} ${value} ${UNITS[um ?? '']?.name ?? ''} ${copy('of')} ${quantity} ${
            UNITS[um ?? '']?.name ?? ''
          }`}
        </span>,
        <AppButton variant='secondary' key='gungnir-rim-cancel' onClick={cancel}>
          {copy('cancel')}
        </AppButton>,
        <AppButton variant='primary' key='gungnir-rim-reject' onClick={reject}>
          {copy('reject')}
        </AppButton>
      ]}
    >
      <RejectItem product={product} copy={copy} onChange={change} />
    </AppModal>
  )
}
